var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('media-library',{attrs:{"headers":['filename', 'name', 'description', 'pages', 'actions'],"textbook":_vm.activeTextbook,"textbook-issue-id":_vm.$route.params.textbookIssueId,"current-issue-only":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }